import { FC } from 'react';
import { Box, Text } from '@chakra-ui/react';
import { useCrucible } from 'hooks/query/useCrucible';
import NFT from 'components/crucible/detail/view/NFT';
import { useParams } from 'react-router-dom';
import { unshuffleAddress } from 'utils/address';
import { useWeb3React } from 'hooks/web3';
import CrucibleMembership from 'components/crucible/CrucibleMembership';
import { useConfig } from 'store/config';
import { getAddress } from '@ethersproject/address';
import ArtworkUnavailable from 'components/crucible/ArtworkUnavailable';
import WebglUnavailable from 'components/crucible/WebglUnavailable';
import { webglSupport } from 'utils/checkWebgl';

const CrucibleNFT: FC = () => {
  const { account, chainId = 1 } = useWeb3React();
  const { artworkWhitelist } = useConfig(chainId).commonConfig;
  const { shuffledAddress, screenshot } =
    useParams<{ shuffledAddress: string; screenshot: string }>();
  const unshuffledAddress = unshuffleAddress(shuffledAddress, 'crucible');

  const isPublic = shuffledAddress.substring(0, 2) === '0x';
  const crucibleAddress = isPublic ? shuffledAddress : unshuffledAddress;
  const screenshotMode = screenshot === 'true';

  const { data: crucible, isLoading } = useCrucible(crucibleAddress);
  const hasWebglSupport = webglSupport();

  if (!crucible && !isLoading) {
    return (
      <Text textAlign='center' mt={16}>
        Crucible not found at this address
      </Text>
    );
  }

  if (!crucible) {
    return null;
  }

  if (
    chainId !== 1 &&
    !(account && artworkWhitelist.includes(getAddress(account!)))
  ) {
    return <ArtworkUnavailable chainId={chainId} />;
  }

  if (crucible.membership === 'basic') {
    return <CrucibleMembership crucible={crucible} readOnly={true} />;
  }

  if (!hasWebglSupport) {
    return <WebglUnavailable />;
  } else {
    // TODO: Make sure NFT is aware of network in param once artwork is supported on other chains
    return (
      <Box zIndex={3} position='relative'>
        <NFT
          crucible={crucible}
          forceFullscreen
          idTextVisible={isPublic}
          screenshotMode={screenshotMode}
        />
      </Box>
    );
  }
};

export default CrucibleNFT;
